/**
 * The locations route paths — mirrors `support/paths.ts`. Kept apart from `routes.tsx` for the
 * same reason: the list screen links into the detail screen and the detail screen links back, so a
 * path builder in the route tree module would make the two screens import each other.
 */
export const locationsRoutePath = '/locations';

export const locationPath = (id: number): string => `${locationsRoutePath}/${String(id)}`;

/** Declared before `/:id` in `routes.tsx`, the same way `content/routes.tsx` orders `:type/new`. */
export const newLocationRoutePath = `${locationsRoutePath}/new`;
